import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function lazyLoad(view) {
  return () => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/',
    name: 'Login',
    component: lazyLoad("Login")
  },
  {
    path: '/admin',
    component: lazyLoad("Admin/Base"),
    children: [
      {
        path: '/',
        redirect: "/admin/newsList",
      },
      // ..............................................................................
      {
        path: 'newsList',
        name: 'AdminNewsList',
        component: lazyLoad("Admin/NewsList")
      },
      // ..............................................................................
      {
        path: 'employer_accounts',
        name: 'AdminEmployerAccounts',
        component: lazyLoad("Admin/EmployerAccounts")
      },
      {
        path: 'employee_accounts',
        name: 'AdminEmployeeAccounts',
        component: lazyLoad("Admin/EmployeeAccounts")
      },
      // ..............................................................................
      {
        path: 'report_issue',
        name: 'AdminReportIssue',
        component: lazyLoad("Admin/ReportIssue")
      },
      {
        path: 'notification_message',
        name: 'AdminNotificationMessage',
        component: lazyLoad("Admin/NotificationMessage")
      },
      // ..............................................................................
      {
        path: 'videos',
        name: 'AdminVideos',
        component: lazyLoad("Admin/Videos")
      },
      {
        path: 'videosURL',
        name: 'AdminVideosURL',
        component: lazyLoad("Admin/VideosURL")
      },
      // -------------------------------------------------------------
    ]
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
